import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CookieConsent from "@/components/CookieConsent";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Brands from "@/pages/Brands";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import GoogleCallback from "@/pages/GoogleCallback";
import LegalPage from "@/pages/legal/LegalPage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Shell />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

function Shell() {
  const { pathname } = useLocation();
  return (
    <>
      <SmoothScroll />
      <ScrollToTop />
      <Header />
      <CartDrawer />
      <main>
        <ErrorBoundary routeKey={pathname}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produse" element={<Catalog />} />
            <Route path="/produs/:slug" element={<ProductDetail />} />
            <Route path="/branduri" element={<Brands />} />
            <Route path="/despre-noi" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cos" element={<Cart />} />
            <Route path="/finalizare" element={<Checkout />} />
            <Route path="/autentificare" element={<Auth />} />
            <Route path="/cont" element={<Account />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/termeni" element={<LegalPage />} />
            <Route path="/confidentialitate" element={<LegalPage />} />
            <Route path="/cookies" element={<LegalPage />} />
            <Route path="/livrare-plata" element={<LegalPage />} />
            <Route path="/retur" element={<LegalPage />} />
            <Route path="/anpc" element={<LegalPage />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="top-center" richColors offset={90} />
    </>
  );
}

export default App;
